// extracted by mini-css-extract-plugin
export default {"Container":"skeleton_Container__awDt1","wrapper":"skeleton_wrapper__Yv8Wc"};